export const CONTENT_TEXTS = {
  TABLE_EXAMPLE: [
    { name: 'Elon Musk', title: 'Space Pioneer' },
    { name: 'Carolyn Porco', title: 'Planetary Visionary' },
    { name: 'Sally Ride', title: 'Trailblazing Astronaut' },
    { name: 'Chris Hadfield', title: 'Orbital Maestro' },
    { name: 'Kathy Sullivan', title: 'Aquanaut Explorer' },
    { name: 'Mae Jemison', title: 'Spacefront Pioneer' },
    { name: 'Roberta Bondar', title: 'Celestial Observer' },
    { name: 'Gwynne Shotwell', title: 'Rocketry Strategist' },
    { name: 'Jeff Bezos', title: 'Cosmic Entrepreneur' },
    { name: 'Richard Branson', title: 'Starry Voyager' },
    { name: 'Peggy Whitson', title: 'Space Laboratory Pioneer' },
    { name: 'Scott Kelly', title: 'Year-in-Space Veteran' },
  ],
};
